var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureFileWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.241,
    height: 19.5,
    viewBox: "0 0 19.241 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160670",
    "data-name": "Group 160670",
    transform: "translate(-40.25 -440.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160650",
    "data-name": "Group 160650",
    transform: "translate(41 441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160575",
    "data-name": "Group 160575",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "secure_file_Filled",
    "data-name": "secure file_Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M57.783,49.3a2.821,2.821,0,0,1-2.77,2.325H48.5a2.813,2.813,0,0,1-2.809-2.8V38.372a2.813,2.813,0,0,1,2.809-2.8h6.514a2.786,2.786,0,0,1,1.97.814",
    transform: "translate(-45.69 -33.624)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M62.888,53.37a2.922,2.922,0,0,1-2.048.84",
    transform: "translate(-48.912 -37.497)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_352",
    d: "M64.435,49.01H59.648a1.027,1.027,0,0,1-1.028-1.028V44.058a1.027,1.027,0,0,1,1.028-1.028h5.486a1.027,1.027,0,0,1,1.028,1.028V47.5",
    transform: "translate(-48.421 -35.256)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    d: "M65.093,41.579V39.9a1.971,1.971,0,0,0-1.97-1.97H62.48a1.971,1.971,0,0,0-1.97,1.97h0v1.679H65.1Z",
    transform: "translate(-48.827 -34.143)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    cx: 0.447,
    cy: 0.447,
    r: 0.447,
    transform: "translate(17.105 13.301)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x1: 4.576,
    transform: "translate(3.064 9.732)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x1: 4.576,
    transform: "translate(3.064 13.247)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M50.008,41.03H48.69",
    transform: "translate(-45.625 -34.813)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M48.69,35.028a2.947,2.947,0,0,1,2.766-1.938h6.809a2.943,2.943,0,0,1,2.743,1.876",
    transform: "translate(-46.336 -33.09)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileWhiteIcon);
export default __webpack_public_path__ + "static/media/secure-file-white-icon.f36f9f700ab726e4e1f0c27d3a4e6208.svg";
export { ForwardRef as ReactComponent };